import { render } from "./fee-warning.vue?vue&type=template&id=67493a19&scoped=true"
import script from "./fee-warning.vue?vue&type=script&lang=js"
export * from "./fee-warning.vue?vue&type=script&lang=js"

import "./fee-warning.vue?vue&type=style&index=0&id=67493a19&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67493a19"]])

export default __exports__